var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('NavHeader'),_c('div',{staticClass:"main"},[_c('keep-alive',[(!_vm.$route.meta.noAlive)?_c('router-view'):_vm._e()],1),(_vm.$route.meta.noAlive)?_c('router-view'):_vm._e()],1),_c('Myfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }